import React from 'react';
import PropTypes from 'prop-types';
import { useRanger } from 'react-ranger';

const RangeStyles = {
  TRACK: {
    height: '3px',
    background: '#ddd',
    borderRadius: '2px',
    margin: '10px',
  },
  SEGMENT: {
    height: '3px',
  },
  TICK: {
    margin: '10px 0 0 -14px',
    fontSize: '12px',
    fontStyle: 'italic',
  },
  HANDLE: {
    width: '18px',
    height: '18px',
    borderRadius: '100%',
    background: '#167efb',
    cursor: 'pointer',
  },
};

function YearRange(props) {
  const { getTrackProps, ticks, segments, handles } = useRanger({
    stepSize: 1,
    onChange: props.onChange,
    values: props.values,
    min: props.min,
    max: props.max,
    ticks: [props.min, props.max],
  });

  return (
    <>
      <label>Year</label>
      <div>
        {props.values[0]} - {props.values[1]}
      </div>
      <div {...getTrackProps({ style: RangeStyles.TRACK })}>
        {segments.map(({ getSegmentProps }, i) => (
          <div
            {...getSegmentProps({
              style: {
                ...RangeStyles.SEGMENT,
                background: i === 1 ? '#167efb' : '#ddd',
              },
            })}
          />
        ))}
        {ticks.map(({ value, getTickProps }) => (
          <div {...getTickProps({ style: RangeStyles.TICK })}>{value}</div>
        ))}
        {handles.map(({ getHandleProps }) => (
          <div {...getHandleProps({ style: RangeStyles.HANDLE })} />
        ))}
      </div>
    </>
  );
}

YearRange.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func,
  values: PropTypes.array,
};

export default YearRange;
